module.exports = __webpack_public_path__ + "img/ilus02.024ff0c8.gif";